module.exports = __webpack_public_path__ + "assets/img/2.506d4406.png";